const TEXT = 'text';
const IMAGE = 'image';
const LINK = 'link';
const VIDEO = 'video';
const MULTIPLE_CHOICES = 'multiple-choice';
const OPEN_QUESTION = 'open-question';
const MEETING = 'meeting';

export const COMPONENT_TYPES = {
  TEXT,
  IMAGE,
  LINK,
  VIDEO,
  MULTIPLE_CHOICES,
  OPEN_QUESTION,
  MEETING,
};

export const MAX_BIT_COMPONENT = 5;

export const INTERACTIVE = [MULTIPLE_CHOICES, OPEN_QUESTION, MEETING];

export enum FIELDS {
  TITLE = 'title',
  DESC = 'description',
  THUMBNAIL = 'thumbnailId',
  TAGS = 'tags',
  DATE = 'date',
  BITS = 'bits',
}

export enum BIT_FIELDS {
  TITLE = 'title',
  DURATION = 'duration',
  COMPONENT = 'component',
}
